import EquipmentTable from './EquipmentTable'
import equipmentTableContainer from './equipmentTableContainer'

export default equipmentTableContainer(EquipmentTable)
